export enum ForwardPricingType {
  AUTO,
  MANUAL,
}

export namespace ForwardPricingType {
  let elements = [ForwardPricingType.AUTO, ForwardPricingType.MANUAL];
  let alias = "com.bcdfx.model.ForwardPricingType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
